import { Component } from '@angular/core';
import { constants } from '../../constants/app-contants';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
  imports: [RouterLink, NgOptimizedImage, ButtonComponent, RouterLinkActive],
  standalone: true,
})
export class NavHeaderComponent {
  menuItems = [
    {
      name: 'About Us',
      icon: '',
      href: '/about-us',
      hidden: false,
      subMenus: [],
      isActive: false,
    },
    {
      name: 'Join LM Tribe',
      icon: '',
      href: '/join-tribe',
      hidden: false,
      subMenus: [],
      isActive: false,
    },
    {
      name: 'Events',
      icon: '',
      href: '/events',
      hidden: false,
      subMenus: [],
      isActive: false,
    },
    {
      name: 'Shop',
      icon: '',
      href: '/shop',
      hidden: false,
      subMenus: [],
      isActive: true,
    },
    {
      name: 'Contact',
      icon: '',
      href: '/contact-us',
      hidden: false,
      subMenus: [],
      isActive: false,
    },
  ];

  onNavigateToTribe() {
    window.open(constants.TRIBE_URL, '_blank');
  }
}
